import React from 'react';
// import test from 'http://127.0.0.1:8000/storage/images/gW6CAWqBcCeHYi8xQMd4lFEWyji1h2PIRFHeJmu2.jpg';

const Test = () => {
  return (
    <img
      src="http://127.0.0.1:8000/storage/images/gW6CAWqBcCeHYi8xQMd4lFEWyji1h2PIRFHeJmu2.jpg"
      alt=""
    />
  );
};

export default Test;
